import styled, { InterpolationValue } from 'styled-components';
import { dropShadow } from '../../../common/styles/Layout';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { FONT_STACK } from '../../../common/styles/constants';
import { onMobile } from '../../../common/styles/onMobile';
import { DROPDOWN_VERTICAL_PADDING } from '../overlay/Dropdown';

const LINE_HEIGHT = 21;
const VERTICAL_PADDING = 32;
const MOBILE_VERTICAL_PADDING = 24;

type Props = {
  onReset: VoidFunction;
  onApply: VoidFunction;
};

export const FilterActions = ({ onReset, onApply }: Props) => (
  <FilterPlaceholder>
    <FilterContainer>
      <Link colour={ThemeColours.mono400} onClick={onReset}>
        Reset
      </Link>
      <Link onClick={onApply}>Apply</Link>
    </FilterContainer>
  </FilterPlaceholder>
);

const Link = styled.span<{ colour?: InterpolationValue }>`
  ${FONT_STACK};
  color: ${props => props.colour || ThemeColours.primary};
  cursor: pointer;
  font-size: 18px;
  line-height: ${LINE_HEIGHT}px;
  margin: 0 16px;
`;

const FilterContainer = styled.div<{ mobile?: boolean }>`
  background-color: ${ThemeColours.white};
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  padding: ${VERTICAL_PADDING}px;
  padding-bottom: ${VERTICAL_PADDING - DROPDOWN_VERTICAL_PADDING}px;
  width: 100%;
  ${onMobile} {
    border-top: 1px solid ${ThemeColours.mono200};
    bottom: 0px;
    ${dropShadow};
    justify-content: center;
    padding: ${MOBILE_VERTICAL_PADDING}px;
    position: fixed;
  }
`;

const FilterPlaceholder = styled.div`
  ${onMobile} {
    padding-bottom: ${MOBILE_VERTICAL_PADDING * 2 + LINE_HEIGHT}px;
  }
`;
